"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordMoneyviewService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordMoneyviewService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordMoneyviewService.instance) {
      return CordMoneyviewService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordMoneyviewService.instance = this;
  }
  getProductFeatures() {
    return this.get('moneyView/productFeatures');
  }
  getProductFeatureDetails(productFeatureId) {
    return this.get(`moneyView/productFeatures/${productFeatureId}`);
  }
}
exports.CordMoneyviewService = CordMoneyviewService;
CordMoneyviewService.instance = null;
